<template>
    <div class="Details">
    <section>
        <div class="columns">
            <div class="column is-12" v-if="currentUser && Object.hasOwn(currentUser, 'plan')">

            <b-button class='is-pulled-right mr-2' type='is-primary-x' @click="isAdditionalCredits()">
              Additional credits
            </b-button>
            
            <b-button v-if="!isProPlan()" class='is-pulled-right mr-2' type='is-primary' tag="router-link" size="is-smallx" to="/d/pricing">
                Upgrade to PRO
            </b-button>
            <b-button v-else class='is-pulled-right' type='is-primary mr-2' tag="router-link" size="is-smallx" to="/d/pricing">
                Upgrade credits
            </b-button>
            <b-button v-if="isProPlan()" class='is-pulled-right mr-2' type='x' tag="router-link" size="is-smallx" to="/d/pricing">
                Change plan
            </b-button>
        
    
                <h3 class="title is-4">Plan</h3>
            </div>
        </div>
        <div class="columns">
            <div class="column is-12" v-if="currentUser && Object.hasOwn(currentUser, 'plan')">

                <div class="tile is-ancestor">
  <div class="tile is-6 is-vertical is-parent">
    <div class="tile is-child box">
        
      <p class="title is-5"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"/></svg>
        You are on <strong>{{ currentUser.plan.name }}</strong> plan
    </p>
    
      <p class="title is-6 block">
        Capabilities
      </p>
      <p class="subtitle is-6">
      <span v-if="['free', 'starter'].includes(getUserPlan())">
            <i class="fa fa-minus"></i> Limited features<br>
        </span>
        <span v-else-if="['AppSumo'].includes(currentUser.plan.name)">
          <i class="fa fa-star"></i> Exclusive AppSumo deal<br>
          <i class="fa fa-star"></i> This plan is similar to {{ isProPlan()?'Pro':'Starter' }} <br>
          
        </span>
        
        <i class="fa fa-check"></i> {{ currentUser.plan.projectsLimit > 999?'Unlimited':'Up to '+currentUser.plan.projectsLimit}} projects<br>
        <i class="fa fa-check"></i> {{ currentUser.plan.modelsLimit > 999?'Unlimited':'Up to '+currentUser.plan.modelsLimit}} model's training per project<br>
        <i class="fa fa-check"></i> Up to {{ currentUser.plan.datasetRowsLimit}} records / rows per project<br>
          
    </p>
    <br>
      
    </div>
    
    
  </div>
  <div class="tile is-parent">
    <div class="tile is-child box" v-if="currentUser && currentUser.plan">
        
      <PlanUsage v-if="currentUser" :upgrade="false"/>
    
    </div>
</div>
</div>
<div class="tile is-ancestor">
  <div class="tile is-6 is-vertical is-parent">
    
    <div class="tile is-child box" v-if="currentUser && currentUser.plan && currentUser.payment && (currentUser.payment.method ? currentUser.payment.method == 'appsumo' : false)">
        <b-button class='is-pulled-right' tag="router-link" size="is-smallx" to="/d/pricing">
                    Add license code
                    </b-button>
                    <p class="title is-5">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm64 16v64h64V352H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64H320v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V304zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"/></svg>
                        License</p>
                    <h1 class="title is-6" v-if="currentUser.payment.method != 'stripe'">
                        {{  currentUser.payment.method }} - {{  currentUser.payment.license }}
                    </h1>
                    <h1 class="subtitle is-6">
                        <b-taginput :value="currentUser.payment.licenseCode" :closable="false" readonly></b-taginput>
                    </h1>

                    
                    
                    
    </div>
    <!-- <div class="tile is-child box" v-if="currentUser && currentUser.plan && currentUser.payment && (currentUser.payment.method ? currentUser.payment.method == 'stripe' : true)"> -->
        <div class="tile is-child box" v-else>
        
        <p class="title is-5"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"/></svg>
          Billing</p>
        
                      <h1 class="title is-6">
                          We partner with Stripe for simplified billing
                      </h1>
                      <h1 class="subtitle is-6">
                          Check your payments and invoices
                      </h1>
  
                      <b-button expanded tag="a" type="is-info" href="https://billing.stripe.com/p/login/5kAg0w5Pkgq7gk8aEE" target="_blank">
                      Go to <b>Stripe</b> Billing Painel
                      </b-button>
                      
                      
      </div>
  </div>

  


</div>

           
            
            <!-- {{ usage }} -->
        </div>
        
        </div>
    </section>


    </div>
</template>
<script>
import PlanUsage from '@/components/PlanUsage.vue'
import PromoCode from '@/components/PromoCode.vue'

import mixin from '@/utils/sharedFunctions.js'

export default {
  mixins: [mixin],
     props: ["projectsTotal", "modelsTotal"],
     name: "Settings",
     data: function() {
    return {
        all_users_api_key: 'Z0CDIgI42M5hggX0bpBB61UZswN4NiHNaqqsFIWd',
        organization: null,
        access: ['editor', 'admin'],
        newMemberEmail: null,
        newMemberPermission: 'editor',
        labelPosition: 'left'
    }},
    components: {
        PlanUsage,
        PromoCode
    },
    computed: {
        usage() {
            return this.$store.state.usage
        },
        currentOrg() {
        return this.$store.state.currentOrg;
        },
        currentUser() {
            return this.$store.state.currentUser;
        }
    },
    methods: {
        isAdditionalCredits(){
            
            this.$buefy.snackbar.open(`For additional credits, please mail us at help@metatext.io with the credit amount you need<br>We'll send you a payment link according with the credit amount you want.`)
        },
        getMembers(){
            if (this.currentOrg.members){
                return this.currentOrg.members
            } else {
                this.currentOrg.members = []
                return []
            }
        },
        getApiKey(){
            if(this.currentOrg && this.currentOrg.apiKey != undefined){
              return this.currentOrg.apiKey
            } else {
              return this.all_users_api_key
            }
         },
         renameOrg(){

            let toUpdate = {
                organization: this.currentOrg.organization,
                organizationId: (this.currentOrg) ? this.currentOrg.id : this.$firebase.auth().currentUser.uid,
            }

            this.$store.dispatch("updateOrganization", 
                toUpdate
            );
         },
         addMember(){
            /** Member
             * email: str
             * permission: str
             * signup: bool
             * invited_at: date
             ***/
            let member = {
                email: this.newMemberEmail,
                permission: this.newMemberPermission,
                signup: false
            }

            if (this.currentOrg.members){
                this.currentOrg.members.push(member)
            } else {
                this.currentOrg.members = []
                this.currentOrg.members.push(member)
            }
            

            let currentUserName = (this.currentUser.displayName)? this.currentUser.displayName : this.currentUser.email
            let currentUserId = this.currentUser.id

            // check if any user has this email

            let toUpdate = {
                organizationId: this.currentOrg.id,
                members: this.currentOrg.members
            }

            this.$store.dispatch("updateMembers", 
                toUpdate
            );

            this.$store.dispatch("inviteMember", 
                currentUserId,
                currentUserName,
                this.newMemberEmail
            );

            
         },
         editMember(){},
         removeMember(removeMemberEmail){
            this.currentOrg.members = this.currentOrg.members.filter( m => m.email != removeMemberEmail)

            let toUpdate = {
                userId: this.$firebase.auth().currentUser.uid,
                organization: this.currentOrg.organization,
                members: this.currentOrg.members
            }

            this.$store.dispatch("updateMembers", 
                toUpdate
            );

         }
    },
    mounted(){
        this.$store.dispatch("currentUser")
    },
    created(){
        this.$store.dispatch("currentUser")
        this.$store.dispatch("usage", this.currentUser.id);

    }
   };
</script>